// @Core
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const ERROR_COMPONENT_COMMON_PROPS = {
    'data-testid': 'error-component',
    'variant': VARIANTS.EmptyStatusVariantType.DEFAULT,
  },
  ERROR_COMPONENT_BUTTON_PROPS = {
    'data-testid': 'error-component-button',
    'size': VARIANTS.ButtonSizeType.LARGE,
    'type': VARIANTS.ButtonVariantType.PRIMARY,
  },
  ERROR_FOOTER_BUTTON_GHOST_PROPS = {
    'data-testid': 'error-component-cancel-button',
    'size': VARIANTS.ButtonSizeType.LARGE,
    'type': VARIANTS.ButtonVariantType.PRIMARY_GHOST,
  };

export {
  ERROR_COMPONENT_BUTTON_PROPS,
  ERROR_COMPONENT_COMMON_PROPS,
  ERROR_FOOTER_BUTTON_GHOST_PROPS,
};
